/** @format */

export const domain = "https://admin.klc-kw.com/api";
export const url = "https://admin.klc-kw.com/api/admin/dashboard";
export const imgUrl = "https://admin.klc-kw.com/storage/";
export const jwt = localStorage.getItem("jwt");
